import { FetchCriteriaModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';

export class ReportRequestModel {
    class: string;
    fetchCriteria: FetchCriteriaModel;
    licenseProvisionStatus: Array<string>;

    constructor() {
        this.fetchCriteria = undefined;
        this.class = undefined;
        this.licenseProvisionStatus = undefined;
    }
}

export class MDMDetails {
    productCode: string;
    ibmEmmAccountId: string;
    googleEmmAccountId: string;
    samsungEmmAccountId: string;
    appleEmmAccountId: string;
    latestAccountType: string;

    constructor() {
        this.productCode = undefined;
        this.ibmEmmAccountId = undefined;
        this.googleEmmAccountId = undefined;
        this.samsungEmmAccountId = undefined;
        this.appleEmmAccountId = undefined;
        this.latestAccountType = undefined;
    }
}
